import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom';
import AppLayout from '../containers/AppLayout';
import enviro from 'enviro';
import HomepageContent from './HomepageContent';
import CodeOfConductPage from './CodeOfConduct/CodeOfConductPage';
export const Paths = {
  HOME: '/'
};
export const Routes = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Route, {
    path: "/member/:memberId",
    render: ({
      match: {
        params
      }
    }) => {
      window.location.replace(`https://app.hubspot${enviro.isQa() ? 'qa' : ''}.com/connect/member/${params.memberId}`);
      return null;
    }
  }), /*#__PURE__*/_jsx(AppLayout, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/code-of-conduct",
        component: CodeOfConductPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/",
        component: HomepageContent
      })]
    })
  })]
});